import { useGameStore } from '../state/gameStore';
import { ArcadePanel } from './ArcadePanel';
import { MarketPanel } from './MarketPanel';
import { RaidPanel } from './RaidPanel';
import { SettingsPanel } from './SettingsPanel';
import { VaultPanel } from './VaultPanel';

export function ActivePanel() {
  const panel = useGameStore((state) => state.activePanel);
  if (panel === 'market') return <MarketPanel />;
  if (panel === 'raid') return <RaidPanel />;
  if (panel === 'vault') return <VaultPanel />;
  if (panel === 'arcade') return <ArcadePanel />;
  if (panel === 'settings') return <SettingsPanel />;
  return null;
}

